import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import * as fromRoot from '../reducers';
import * as fromShared from '../reducers';
import {Observable, of} from 'rxjs';
import {Role} from '../models/role';
import {Resolve} from '@angular/router';
import { CUSTOM_CLAIMS_DEFAULT_CLIENT_ID, LoadRolesAction} from '..';
import {skipUntil, skipWhile} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RolesService implements Resolve<Observable<Role[]>> {
  readonly roles$: Observable<Role[]>;
  public _roles: Role[];

  constructor(private store: Store<fromRoot.AppState>) {
    this.roles$ = this.store.pipe(select(fromShared.selectors.getMyRoles));
    this.roles$.pipe(skipUntil(this.roles$), skipWhile(data => !data || (data && !data.length))).subscribe((roles: Role[]) => {
      this._roles = roles
    });
  }

  isRole(role: string): boolean {
    return this._roles ? this._roles.filter((data: Role) => data.code === role).length === 1 : false;
  }

  resolve(): Observable<Role[]> {
     this.store.pipe(select(fromShared.selectors.getUserInfo)).subscribe((userInfo) => {
       if (userInfo) {
         this.store.dispatch(new LoadRolesAction(userInfo[CUSTOM_CLAIMS_DEFAULT_CLIENT_ID]));
     }
    });
     return of(this._roles); // TODO: get realy need ?
  }
}
